/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
// import NoData from "../../../components/NoData/NoData";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { isEmpty, cloneDeep, isUndefined } from "lodash";
import { permissionCheck } from "../../../utils/permission";

import { excelUploadTaxInvoice, getTaxInvoiceExcel, getTaxInvoiceItemExcel } from "../../../apis/invoices";
import { getExcelDownParams } from "../../../utils/params";
import { downExcelFile } from "../../../utils/download";

import { viewLoading } from "../../../utils/loading";
import Modal, { ModalHeader } from "../../../components/Modal";
import { ModalBody } from "reactstrap";
import Col from "../../../components/ContentLayout/Col";
import Row from "../../../components/ContentLayout/Row";
import DataComponent from "../../../components/DataComponent";
import PaperTaxInvoiceSales from "./PaperTaxInvoiceSales";
import PaperTaxInvoicePurchase from "./PaperTaxInvoicePurchase";
import paperTaxInvoiceFreeSample from "../../../assets/file/paperTaxInvoiceFreeSample.xls";
import paperTaxInvoiceTaxSample from "../../../assets/file/paperTaxInvoiceTaxSample.xls";
import systemAlert from "../../../utils/systemAlert";

const ElectronicTaxBill = (props) => {
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const { company } = useSelector((store) => store.Profile);

  const history = useHistory();
  const [activeTab, setActiveTab] = useState("sales");
  const [open, setOpen] = useState(false);
  const [targetPermission, setTargetPermission] = useState(null);

  const [form, setForm] = useState(null);
  const [isExcelUploadModal, setIsExcelUploadModal] = useState(false);
  const [taxInvoiceType, setTaxInvoiceType] = useState("paper_tax_invoice");

  const [isExcelDownloadModal, setIsExcelDownloadModal] = useState(false);

  const uploadExcelFile = (e, type, tax) => {
    const file = e.target.files[0];

    if (!isUndefined(file)) {
      systemAlert(`"${file.name}" 파일을 업로드 하시겠습니까?`, {
        buttons: [
          {
            color: "text",
            label: "취소",
          },
          {
            label: "확인",
            onClick: () => {
              viewLoading("종이세금계산서 등록중 입니다.");
              const formData = new FormData();
              formData.append("file", file);

              excelUploadTaxInvoice(
                activeTab === "sales" ? "sales" : "purchase",
                tax,
                formData
              )
                .then(() => {
                  systemAlert('종이세금계산서가 등록되었습니다.', {
                    buttons: [{
                      label: "확인",
                      onClick: () => {
                        setOpen(false);
                        window.location.reload();
                      }
                    }]
                  });
                })
                .catch((err) => console.error(err))
                .finally(() => viewLoading(false));
            },
          },
        ],
      });
    }
  };

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'TAX_INVOICE');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "TAX_INVOICE");
      }
    }
  }, [permissions]);

  const _setActiveTab = (value) => {
    history.push(`/electronic/bill-paper-tax?tab=${value}`);
  };

  const tabList = [
    { label: "매출", action: _setActiveTab, value: "sales" },
    { label: "매입", action: _setActiveTab, value: "purchases" },
    // { label: "발행내역", action: _setActiveTab, value: "history" },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  useEffect(() => {
    setForm(null);
  }, [activeTab]);

  const headerButtons = [
    {
      // isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      isHide: targetPermission && targetPermission.level <= 1,
      color: "text",
      label: '엑셀 업로드',
      action: () => {
        setIsExcelUploadModal(true);
      }
    },
    {
      isHide: targetPermission && targetPermission.level <= 1,
      color: "text",
      label: '엑셀 다운로드',
      action: () => {
        setIsExcelDownloadModal(true);
      },
    },
    {
      label: "발급하기",
      action: () => {
        setOpen(true);
      },
    },
  ];

  const handleExcelDown = ({ form, taxInvoiceType, invoiceRegged }) => {
    setForm(form);
    setTaxInvoiceType(taxInvoiceType);
  };

  const excelUploadButtons = [
    {
      // isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      isHide: targetPermission && targetPermission.level <= 1,
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          {`${activeTab === "sales" ? "매출" : "매입"}`}(면세) 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = paperTaxInvoiceFreeSample;
        a.style.display = "none";
        a.download = "paperTaxInvoiceFreeSample";
        document.body.appendChild(a);
        a.click();
      },
    },
    {
      isHide: targetPermission && targetPermission.level <= 1,
      // isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      label: `${activeTab === "sales" ? "매출" : "매입"}(면세) 엑셀 업로드`,
      color: "gray-line",
      size: "sm",
      key: "purchases_free",
      type: "excelfile",
      onChange: (e) => uploadExcelFile(e, activeTab, 'free'),
    },
    {
      isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      color: "text",
      size: "sm",
      type: 'button',
      label: (
        <>
          {`${activeTab === "sales" ? "매출" : "매입"}`}(과세/영세) 샘플 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        const a = document.createElement("a");
        a.href = paperTaxInvoiceTaxSample;
        a.style.display = "none";
        a.download = "paperTaxInvoiceTaxSample";
        document.body.appendChild(a);
        a.click();
      },
    },
    {
      isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      label: `${activeTab === "sales" ? "매출" : "매입"}(과세/영세) 엑셀 업로드`,
      color: "gray-line",
      size: "sm",
      key: "purchases_tax",
      type: "excelfile",
      onChange: (e) => uploadExcelFile(e, activeTab, 'tax'),
    },
  ];

  const excelDownloadButtons = [
    {
      isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      label: (
        <>
          {`${activeTab === "sales" ? "매출" : "매입"} 엑셀 다운로드`} <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      type: 'button',
      color: "gray-line",
      size: "sm",
      action: () => {
        let _params = cloneDeep(form);
        if (!isEmpty(_params["range.writeDate"])) {
          _params.range.writeDate = {
            from: _params["range.writeDate"][0],
            to: _params["range.writeDate"][1]
          };
          delete _params["range.writeDate"];
        }
        //getTaxInvoiceList("purchase", taxInvoiceType, { ...getParams(_params) })

        viewLoading("엑셀 다운로드 중입니다.");
        getTaxInvoiceExcel(`${activeTab === "sales" ? "sales" : "purchase"}`, taxInvoiceType, { ...getExcelDownParams(_params) }).then((res) => {
          let title = `${activeTab === "sales" ? "매출" : "매입"}_전자(세금)계산서_목록`;
          if (company && !isEmpty(company)) {
            title = company.name + '_' + title;
          }
          downExcelFile(res, title);
        }).finally(() => {
          viewLoading(false);
        });
      },
    },
    {
      isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      label: (
        <>
          {`${activeTab === "sales" ? "매출" : "매입"} 품목별 엑셀 다운로드`} <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      type: 'button',
      color: "gray-line",
      size: "sm",
      action: () => {
        let _params = cloneDeep(form);
        if (!isEmpty(_params["range.writeDate"])) {
          _params.range.writeDate = {
            from: _params["range.writeDate"][0],
            to: _params["range.writeDate"][1]
          };
          delete _params["range.writeDate"];
        }
        //getTaxInvoiceList("purchase", taxInvoiceType, { ...getParams(_params) })

        viewLoading("엑셀 다운로드 중입니다.");
        getTaxInvoiceItemExcel(`${activeTab === "sales" ? "sales" : "purchase"}`, taxInvoiceType, { ...getExcelDownParams(_params) }).then((res) => {
          let title = `${activeTab === "sales" ? "매출" : "매입"}_품목별_전자(세금)계산서_목록`;
          if (company && !isEmpty(company)) {
            title = company.name + '_' + title;
          }
          downExcelFile(res, title);
        }).finally(() => {
          viewLoading(false);
        });
      },
    },
  ];

  return (
    !isEmpty(targetPermission) && (
      <div className="print-out">
        <PageHeader
          title={"종이(세금)계산서"}
          tabList={tabList}
          activeTab={activeTab}
          buttons={targetPermission.level > 1 ? headerButtons : []}
        />
        {activeTab === "sales" && (
          <PaperTaxInvoiceSales
            permission={targetPermission}
            open={open}
            setOpen={setOpen}
            excelDown={handleExcelDown}
          />
        )}
        {
          activeTab === "purchases" && (
            <PaperTaxInvoicePurchase
              permission={targetPermission}
              open={open}
              setOpen={setOpen}
              excelDown={handleExcelDown}
            />
          )
        }
        <Modal size="md" isOpen={isExcelUploadModal} close={() => setIsExcelUploadModal(false)}>
          <ModalHeader>엑셀 업로드</ModalHeader>
          <ModalBody>
            <Row>
              <Col style={{ textAlign: 'center', }}>
                <DataComponent field={{ ...excelUploadButtons[3] }} />
                <DataComponent field={{ ...excelUploadButtons[2] }} />
              </Col>
              <Col style={{ textAlign: 'center', }}>
                <DataComponent field={{ ...excelUploadButtons[1] }} />
                <DataComponent field={{ ...excelUploadButtons[0] }} />
              </Col>
            </Row>
          </ModalBody>
        </Modal>
        <Modal size="md" isOpen={isExcelDownloadModal} close={() => setIsExcelDownloadModal(false)}>
          <ModalHeader>엑셀 다운로드</ModalHeader>
          <ModalBody>
            <Row>
              <Col style={{ textAlign: 'center', }}>
                <DataComponent field={{ ...excelDownloadButtons[0] }} />
              </Col>
              <Col style={{ textAlign: 'center', }}>
                <DataComponent field={{ ...excelDownloadButtons[1] }} />
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    ));
};

export default ElectronicTaxBill;
